import React, { useEffect, useState } from "react";
import { casinoPageData } from "./../../../lib/data";

import Cross from "../../../assets/images/icons/cross-icon.svg";
import Casino from "../../../assets/images/icons/Casino-wt.svg";

import CasinosAllGames, {
  STATIC_CATEGORIES,
} from "./../../components/CasinosAllGames";
import { useLocation, useNavigate } from "react-router-dom";

const tabsData = [
  { id: 0, name: "All", key: "alls" },
  { id: 1, name: "Ezugi", key: "ezugi" },
  { id: 2, name: "Mac88", key: "mac88" },
  { id: 3, name: "Mac88 Virtuals", key: "mac88VR" },
  { id: 4, name: "SmartSoft Gaming", key: "smartSoft" },
  { id: 5, name: "NetEnt", key: "netent" },
  { id: 6, name: "Jili", key: "jili" },
  { id: 7, name: "Evolution", key: "evolution" },
  { id: 8, name: "Red Tiger", key: "redtiger" },
  { id: 9, name: "Slots", key: "slots" },
  { id: 10, name: "Vivo", key: "vivo" },
  { id: 11, name: "Instant Win", key: "instantWin" },
  { id: 12, name: "Supernowa", key: "supernowa" },
  { id: 13, name: "XPG", key: "xpg" },
  { id: 14, name: "Crash", key: "crashGames" },
  { id: 15, name: "Powergames", key: "powergames" },
  { id: 16, name: "Aura Gaming", key: "auragaming" },
  { id: 17, name: "Kingmaker", key: "kingmaker" },
  { id: 18, name: "Spribe", key: "spribe" },
  { id: 19, name: "Hacksaw", key: "hacksaw" },
  { id: 20, name: "Turbo", key: "turbo" },
  { id: 21, name: "Play'n Go", key: "playNGo" },
  { id: 22, name: "Relax Gaming", key: "relaxGaming" },
  { id: 23, name: "Habanero", key: "habanero" },
  { id: 24, name: "Dragoon Soft", key: "dragoonSoft" },
];

const Casinos = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const provider = searchParams.get("provider") || "alls";
  const category = searchParams.get("category") || "all";

  const [providerKey, setProviderKey] = useState("alls");
  const [keyDataToRender, setKeyDataTorender] = useState("all");
  const [dataTorender, setDataToRender] = useState([]);

  const [search, setSearch] = useState("");
  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearch(searchValue);
    if (searchValue) {
      const filteredData = Object.values(
        keyDataToRender === "all"
          ? Object.values(casinoPageData?.[providerKey] || {})
              .map((item) => Object.values(item))
              .flat()
          : casinoPageData?.[providerKey]?.[keyDataToRender] || {}
      ).filter(
        (item) => item?.name && item?.name?.toLowerCase().includes(searchValue)
      );
      setDataToRender(filteredData);
    } else {
      if (keyDataToRender === "all") {
        setDataToRender(
          Object.values(casinoPageData?.[providerKey] || {})
            .map((item) => Object.values(item))
            .flat()
        );
      } else {
        setDataToRender(casinoPageData?.[providerKey]?.[keyDataToRender] || {});
      }
    }
  };

  useEffect(() => {
    if (typeof provider === "string") {
      setProviderKey(provider);
    }
  }, [provider]);

  useEffect(() => {
    if (keyDataToRender === "all") {
      const allItems = Object.values(casinoPageData?.[providerKey] || {})
        .map((item) => Object.values(item))
        .flat();
      setDataToRender(allItems);
    } else {
      const specificData =
        casinoPageData?.[providerKey]?.[keyDataToRender] || [];
      setDataToRender(specificData);
    }
  }, [keyDataToRender, providerKey]);

  const getCategoryIcon = (ctg) => {
    const category = STATIC_CATEGORIES.find((f) => f?.category === ctg);
    if (category) {
      return category;
    }
    return { img: "", name: "" };
  };

  /**
   *
   * @param { string | null | undefined} value
   * @returns {boolean}
   */
  const isValidValue = (value) => {
    let bool = true;
    if (!value) {
      bool = false;
    }
    if (value === "") {
      bool = false;
    }
    if (!Boolean(value)) {
      bool = false;
    }
    return bool;
  };

  return (
    <>
      <div className="container-fluid">
        <div className="main-wrapper mb-4">
          <main className="">
            <div className="casino-games bg-brdr">
              <div className="tabs providers">
                <select
                  value={providerKey}
                  onChange={(e) => setProviderKey(e.target.value)}
                  className="provider-select"
                >
                  {tabsData?.map((item) => (
                    <option key={item?.id} value={item?.key}>
                      {item?.name}
                    </option>
                  ))}
                </select>
              </div>

              {providerKey === "alls" ? (
                <CasinosAllGames defaultCategory={"all"} search={search} />
              ) : (
                <>
                  <div className="tabs categories">
                    {providerKey !== "alls" && (
                      <div
                        onClick={() => setKeyDataTorender("all")}
                        className={`tab ${
                          keyDataToRender === "all" ? "active" : ""
                        }`}
                      >
                        All
                      </div>
                    )}
                    {Object.keys(casinoPageData?.[providerKey])?.map(
                      (item, idx) => {
                        return (
                          <div
                            key={idx}
                            onClick={() => setKeyDataTorender(item)}
                            className={`tab ${
                              getCategoryIcon(item)?.class || ""
                            } ${keyDataToRender === item ? "active" : ""}`}
                          >
                            <img
                              src={getCategoryIcon(item)?.img}
                              alt={getCategoryIcon(item)?.name}
                            />
                            {isValidValue(getCategoryIcon(item)?.name)
                              ? getCategoryIcon(item)?.name
                              : item}
                          </div>
                        );
                      }
                    )}
                  </div>

                  <div className="game-list">
                    {Object.values(dataTorender).map((item, index) => {
                      return (
                        <div
                          className="game"
                          key={index}
                          onClick={() => navigate(item?.href)}
                        >
                          
                          <img
                            src={item.imgUrl}
                            alt={item.alt}
                            width={200}
                            height={150}
                          />
                          {/* <p>{item.name}</p> */}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
              {/* {providerKey === "alls" && <CasinosAllGames />} */}
            </div>
          </main>
        </div>
      </div>
    </>
  );
};
export default Casinos;
